<template>
  <Listbox v-slot="{ value }">
    <div class="relative w-40">
      <ListboxButton
        class="relative w-full text-foreground cursor-default h-11 hover:shadow rounded bg-surface border py-1 pl-3 pr-7 focus:outline-none focus-visible:border-indigo-500 focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-opacity-75 focus-visible:ring-offset-2 focus-visible:ring-offset-orange-300">
        <span v-if="value" class="block truncate font-bold">
          <span class="flex gap-1 items-baseline">
            <b>{{ item.amount }}</b
            >&times; {{ formatCurrency(item.ticket.local_rates.net_rate_eur, "EUR") }}
          </span>
        </span>
        <span v-else>
          <span>
            {{ $t("Add") }}
          </span>
        </span>
        <span class="pointer-events-none absolute inset-y-0 right-2 flex items-center">
          <ChevronUpDownIcon class="h-5" />
        </span>
      </ListboxButton>
      <ListboxOptions
        class="z-20 absolute mt-2 max-h-200 w-full overflow-auto rounded-md bg-menu py-1 shadow-lg ring-1 ring-black/5 focus:outline-none lg:text-base">
        <ListboxOption
          v-for="option in options.filter(Boolean)"
          v-slot="{ active }"
          :key="option"
          :value="option?.n"
          as="template">
          <li
            :class="[
              active ? 'bg-primary text-btn-forecolor' : 'text-foreground',
              'relative bg-surfuce cursor-default select-none py-2 px-4',
            ]">
            <span v-if="option?.n" class="block lg:truncate text-center">
              <span class="flex gap-1 items-baseline">
                <b>{{ option.n }}</b
                >&times; {{ formatCurrency(option.ticket?.local_rates.net_rate_eur ?? 0, "EUR") }}
              </span>
            </span>
            <span v-else class="block lg:truncate">
              {{ $t("Remove") }}
            </span>
          </li>
        </ListboxOption>
      </ListboxOptions>
    </div>
  </Listbox>
</template>

<script setup>
import { formatCurrency } from "@xs2event/js-lib";

defineProps({
  item: { required: true },
  options: { required: true },
});

import { Listbox, ListboxButton, ListboxOptions, ListboxOption } from "@headlessui/vue";

import { ChevronUpDownIcon } from "@heroicons/vue/20/solid";
</script>
